import { render } from "./CriteriaPanelistsPage.vue?vue&type=template&id=742b763e&ts=true"
import script from "./CriteriaPanelistsPage.vue?vue&type=script&lang=ts"
export * from "./CriteriaPanelistsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__